import {
  APIParser,
  AxiosAPIParser,
  APIParserNoMsg,
  APIDownloadFile,
} from "./api-parser";
import { API_URL } from "./api-client";
import { getToken } from "./api-util";
import triyoAPI from "./triyo";

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// CREATE
export const CreateBlankRoleNew = () => {
  return triyoAPI
    .get("/roles/AddRole", config())
    .then((response) => AxiosAPIParser(response));
};

export const CreateRoleNew = (role) => {
  return triyoAPI
    .post("/roles/AddRole", role, config())
    .then((response) => AxiosAPIParser(response));
};

/*
GETS
*/
export const RoleExistsWithNameNew = (name, company) => {
  let searchQuery = {
    PageSize: 100000000,
    PageNumber: 1,
    SortDesc: false,
    SortBy: "name",
    Filters: [],
  };

  return GetAllRolesNew(searchQuery).then(
    (result) => {
      return result.Roles.find((r) => r.Name === name && r.Company == company);
    },
    (fail) => {}
  );
};

export const GetBlankRoleQuery = () => {
  return new Promise((resolve, reject) => {
    resolve({
      pageSize: 10,
      pageNumber: 1,
      sortDesc: false,
      sortBy: "name",
      filters: [],
    });
  });
};

export const GetAllRoles = (searchQuery) => {
  let searchQueryJSON = JSON.stringify(searchQuery);

  return fetch(API_URL + "getallroles/" + 0, {
    method: "POST",
    body: searchQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetAllRolesNew = (searchQuery) => {
  return triyoAPI
    .post("/roles/GetAllRoles", searchQuery, config())
    .then((response) => AxiosAPIParser(response));
};

export const GetAllRolesForDepartmentOld = (departmentID) => {
  return fetch(API_URL + "GetRolesByDepartmentId/" + 0 + "/" + departmentID, {
    method: "GET",
    credentials: "include",
  }).then((response) => APIParser(response));
};

export const GetAllRolesForDepartment = (id) => {
  return triyoAPI.get("/roles/GetRolesByDepartmentId?DepartmentId="+id, config());
}

export const DownloadRoles = () => {
  return fetch(API_URL + "DownloadRoles/" + 0, {
    method: "GET",
    credentials: "include",
  }).then((response) => APIDownloadFile(response));
};

export const DownloadRolesNew = () => {
  return triyoAPI.get("/roles/DownloadRoles", config());
};

// EDITS
export const GetEditRoleNew = (roleID) => {
  return triyoAPI
    .get("/roles/GetRole/" + roleID, config())
    .then((response) => AxiosAPIParser(response));
};

export const EditRoleNew = (role) => {
  return triyoAPI
    .post("/roles/EditRole", role, config())
    .then((response) => AxiosAPIParser(response));
};

// DELETE
export const DeleteRoles = (role) => {
  let roleJson = JSON.stringify(role);

  return fetch(API_URL + "DeleteRoles/" + 0, {
    method: "POST",
    body: roleJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserNoMsg(response));
};

export const DeleteRolesNew = (ids) => {
  return triyoAPI.post("/roles/DeleteRoles", ids, config());
};
